import PolicyComponent from "../components/PolicyComponent";
import usePolicy from "../hook/usePolicy";

const PolicyPage = ({

}) => {
    const policy = usePolicy();
    return <PolicyComponent {...policy} />
}
export default PolicyPage;